import { formTypes } from './reviewForm';

export enum Permission {
  /*
   * See README.md for instructions on how to sync these permission options with the DB.
   */
  AccessAllStudies = 'access_all_studies',
  AccessAnalysisStudio = 'access_analysis_studio',
  AddAndEditClinicalDataToAnyStudies = 'add_and_edit_clinical_data_to_any_studies',
  AddAndEditClinicalDataToOwnStudies = 'add_and_edit_clinical_data_to_own_studies',
  AddAndEditMetadataToAnyStudies = 'add_and_edit_metadata_to_any_studies',
  AddAndEditMetadataToOwnStudies = 'add_and_edit_metadata_to_own_studies',
  AnnotateSlides = 'annotate_slides',
  ApplyCaseManifest = 'apply_case_manifest',
  ApplyFiltersAndSaveQueriesAsCohorts = 'apply_filters_and_save_queries_as_cohorts',
  ApplyPermissionsAcrossLabs = 'apply_permissions_across_labs',
  AppointAdminsPerLab = 'appoint_admins_per_lab',
  ApproveCases = 'approve_cases',
  ArchiveRestoreAllUsersJobs = 'archive_restore_all_users_jobs',
  ArchiveRestoreOwnJobs = 'archive_restore_own_jobs',
  AssignGenericClusters = 'assign_generic_clusters',
  CanArchiveViewRestoreOwnResults = 'can_archive_view_restore_own_results',
  CanDownloadFeatureNamesCsv = 'can_download_feature_names_csv',
  CanToggleAllMultiplexChannels = 'can_toggle_all_multiplex_channels',
  CanUseBetaViewer = 'can_use_beta_viewer',
  CanViewRestoreResultsArchivedByAny = 'can_view_restore_results_archived_by_any',
  CancelAllUsersJobs = 'cancel_all_users_jobs',
  CancelOwnJobs = 'cancel_own_jobs',
  ContinueJob = 'continue_job',
  CreateAnnotationAssignment = 'create_annotation_assignment',
  CreateLab = 'create_lab',
  CreateStudies = 'create_studies',
  CreateTileVectorRepositories = 'create_tile_vector_repositories',
  DefineRolesToLabUsers = 'define_roles_to_lab_users',
  DeleteLab = 'delete_lab',
  DeleteOtherUsersOverviewPreset = 'delete_other_users_overview_preset',
  DownloadCalculatedFeatures = 'download_calculated_features',
  DownloadCellsTable = 'download_cells_table',
  DownloadIntermediateResults = 'download_intermediate_results',
  EditAlgoSourceMapping = 'edit_algo_source_mapping',
  EditAndDeleteAnyCohort = 'edit_and_delete_any_cohort',
  EditAndDeleteOwnCohorts = 'edit_and_delete_own_cohorts',
  EditAnnotationAssignmentTags = 'edit_annotation_assignment_tags',
  EditAreaTypeOptions = 'edit_area_type_options',
  EditCellColorMappings = 'edit_cell_color_mappings',
  EditCellRules = 'edit_cell_rules',
  EditClusterTypeOptions = 'edit_cluster_type_options',
  EditExternalLabelOptions = 'edit_external_label_options',
  EditHiddenFeatures = 'edit_hidden_features',
  EditInferredFeatures = 'edit_inferred_features',
  EditLab = 'edit_lab',
  EditLabCustomerBucketAccessGrants = 'edit_lab_customer_bucket_access_grants',
  CreateOwnCustomerBucketAccessGrants = 'create_own_customer_bucket_access_grants',
  EditLabExternalStorageProviders = 'edit_lab_external_storage_providers',
  EditModelTypeOptions = 'edit_model_type_options',
  EditOtherUsersOverviewPreset = 'edit_other_users_overview_preset',
  EditPlatformSettings = 'edit_platform_settings',
  EditQcQaLabels = 'edit_qc_labels',
  EditSlideTagOptions = 'edit_slide_tag_options',
  EditSlideTagsAssignments = 'edit_slide_tags_assignments',
  EditStainTypeOptions = 'edit_stain_type_options',
  EditStudyAcl = 'edit_study_acl',
  EditStudyAlgorithms = 'edit_study_algorithms',
  EditStudyDefaultOverviewPreset = 'edit_study_default_overview_preset',
  EditStudyNameAndDescription = 'basic_edit_study',
  EditStudyHeatmapSettings = 'edit_study_heatmap_settings',
  EditStudyExportBucketSettings = 'edit_study_export_bucket_settings',
  EditStudyExternalSlideStorageSettings = 'edit_study_external_slide_storage_settings',
  EditStudyPostIngestPipelineSettings = 'edit_study_post_ingest_pipeline_settings',
  EditStudyReportJobCharts = 'edit_study_report_job_charts',
  EditTaxonomyOptions = 'edit_taxonomy_options',
  ExecuteCellSegmentation = 'execute_cell_segmentation',
  ExecuteQuantification = 'execute_quantification',
  ExecuteModelTraining = 'execute_model_training',
  ExecuteMultiplexBinaryClassifier = 'execute_multiplex_binary_classifier',
  ExecuteMultiplexTissueSegmentationMask = 'execute_multiplex_tissue_segmentation_mask',
  ExecuteBrightfieldTissueSegmentationMask = 'execute_brightfield_tissue_segmentation_mask',
  ExecuteMultiplexCellTyping = 'execute_multiplex_cell_typing',
  ExecuteMultiplexBlobSegmentation = 'execute_multiplex_blob_segmentation',
  ExecuteMultiplexHistogram = 'execute_multiplex_histogram',
  ExecuteMultiplexNormalization = 'execute_multiplex_normalization',
  ExecuteMultiplexPeakDetection = 'execute_multiplex_peak_detection',
  ExecuteMultiplexThreshold = 'execute_multiplex_threshold',
  ExecuteNeighborhoodClusters = 'execute_neighborhood_clusters',
  ExecuteCloudOptimizedSlides = 'execute_cloud_optimized_slides',
  ExecuteUploadedSlideIngest = 'execute_uploaded_slide_ingest',
  ExecuteTileGeneration = 'execute_tile_generation',
  ExecuteSlideRegistrations = 'execute_slide_registration',
  ExecuteStudyAlgorithms = 'execute_study_algorithms',
  ExecuteMifMarkerUnsupervisedAnalysis = 'execute_mif_marker_unsupervised_analysis',
  ExecuteManualPostIngestPipeline = 'execute_manual_post_ingest_pipeline',
  ExecuteQaAnalysis = 'execute_qa_analysis',
  ExecuteQcAnalysis = 'execute_qc_analysis',
  ExecuteStudyReport = 'execute_study_report',
  FillForm = 'fill_form',
  HideRestoreStudyUploads = 'hide_restore_study_uploads',
  InitiateAnalysisInAnyStudy = 'initiate_analysis_in_any_study',
  InitiateAnalysisInTheirOwnStudies = 'initiate_analysis_in_their_own_studies',
  LimitAnyStudiesAccess = 'limit_any_studies_access',
  LimitOwnStudiesAccess = 'limit_own_studies_access',
  ManageNucleaiUsers = 'manage_nucleai_users',
  MakeCalculateFeaturesPresetGlobal = 'make_calculate_features_preset_global',
  PrepareApprovedCustomerResultsForDownload = 'prepare_approved_customer_results_for_download',
  PublishResults = 'publish_results',
  PublishCalculateFeaturesPreset = 'publish_calculate_features_preset',
  ReingestUploadedSlides = 'reingest_uploaded_slides',
  RunCalculateFeatures = 'run_calculate_features',
  RunCropTma = 'run_crop_tma',
  RunInference = 'run_inference',
  RunMultiplexCellSegmentation = 'run_multiplex_cell_segmentation',
  RunSecondaryAnalysis = 'run_secondary_analysis',
  ScoreHeatmaps = 'score_heatmaps',
  SeeOrchestrationId = 'see_orchestration_id',
  UpdateHighlightedFeatures = 'update_highlighted_features',
  UploadSlidesToAnyStudies = 'upload_slides_to_any_studies',
  UploadSlidesToOwnStudies = 'upload_slides_to_own_studies',
  UseNucleaiExperimentalFeatures = 'use_nucleai_experimental_features',
  ViewAccessionDashboard = 'view_accession_dashboard',
  ViewAnnotations = 'view_annotations',
  ViewAllCalculateFeaturesPresetDrafts = 'view_all_calculate_features_preset_drafts',
  ViewAnnotationsList = 'view_annotations_list',
  ViewCasesTable = 'view_cases_table',
  ViewClinicalData = 'view_clinical_data',
  ViewFormResponses = 'view_form_responses',
  ViewHeatmapScores = 'view_heatmap_scores',
  ViewInternalSlideLabels = 'view_internal_slide_labels',
  ViewJobs = 'view_jobs',
  ViewJsonJobParams = 'view_json_job_params',
  ViewMetadata = 'view_metadata',
  ViewPendingSlides = 'view_pending_slides',
  ViewQaAnalysisResults = 'view_qa_analysis_results',
  ViewQcAnalysisResults = 'view_qc_analysis_results',
  ViewMifMarkerUnsupervisedAnalysisResults = 'view_mif_marker_unsupervised_analysis_results',
  ViewMultiplexCellSegmentationModelTypeSelection = 'view_multiplex_cell_segmentation_model_type_selection',
  ViewResultsInViewer = 'view_results_in_viewer',
  ViewReviewMenu = 'view_review_menu',
  ViewRoleAllocationPerUser = 'view_role_allocation_per_user',
  ViewSlideReportResults = 'view_slide_report_results',
  ViewSlideThumbnailsNavigation = 'view_slide_thumbnails_navigation',
  ViewSlides = 'view_slides',
  ViewStudies = 'view_studies',
  ViewStudyCellRules = 'view_study_cell_rules',
  ViewStudyReportResults = 'view_study_report_results',
  ViewNucleaiCopilot = 'view_nucleai_copilot',
  ViewCopilotTokenUsage = 'view_copilot_token_usage',
  ViewStudySettings = 'view_study_settings',
  ViewTaxonomy = 'view_taxonomy',
  ViewTaxonomyTags = 'view_taxonomy_tags',
  ViewUnpublishedResults = 'view_unpublished_results',
  ViewWorkflowMonitor = 'view_workflow_monitor',
  EditDeconvolutionVisualizationSettings = 'edit_deconvolution_visualization_settings',
  EditDeconvolutionCalculationSettings = 'edit_deconvolution_calculation_settings',
  ViewQCMarkers = 'view_qc_markers',
  EditQCMarkers = 'edit_qc_markers',
}

export const globalSettingsEditingPermissions = [
  Permission.EditStainTypeOptions,
  Permission.EditExternalLabelOptions,
  Permission.EditSlideTagOptions,
  Permission.EditAreaTypeOptions,
  Permission.EditClusterTypeOptions,
  Permission.EditTaxonomyOptions,
  Permission.EditCellRules,
  Permission.EditModelTypeOptions,
  Permission.EditCellColorMappings,
  Permission.PublishCalculateFeaturesPreset,
  Permission.MakeCalculateFeaturesPresetGlobal,
];

export const globalSettingsViewingPermissions = [
  Permission.ViewTaxonomy,
  Permission.ViewTaxonomyTags,
  Permission.ViewAllCalculateFeaturesPresetDrafts,
];

export const permissionSubOptions = {
  [Permission.ViewFormResponses]: formTypes,
  [Permission.FillForm]: formTypes,
} as const;

export type PermissionSubOptions = typeof permissionSubOptions;

export interface PermissionOption {
  permission: Permission;
  description: string;
}

export const permissionToName = (permission?: PermissionOption, id?: Permission): string =>
  permission ? permission?.description || id || 'Deprecated permission' : 'Deprecated permission';
